module.exports = __webpack_public_path__ + "statics/img/SmartLogistics-1.5b9ea5df.png";